import { Navigate } from 'react-router-dom'

import { LoadingSpinner } from 'components/shared/LoadingSpinner'
import { useAuth } from 'contexts/AuthContext'

import type { ReactElement } from 'react'

interface ProtectedRouteProperties {
  children: ReactElement
}

export const ProtectedRoute = ({ children }: ProtectedRouteProperties): ReactElement => {
  /* --- Section 1: Hooks --- */
  const { user, loading } = useAuth()

  /* --- Section 5: Early Returns --- */
  if (loading) {
    return (
      <div className="App app-shell-loading-state">
        <LoadingSpinner />
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/" replace />
  }

  /* --- Section 6: Render --- */
  return children
}
